import HttpService from "./htttp.service";

class UserGroupService {
  createUserGroup = async (payload, params) => {
    const endpoint = "user-groups";
    return await HttpService.post(endpoint, payload, params);
  };

  getUserGroups = async (params) => {
    const endpoint = "user-groups";
    return await HttpService.get(endpoint, params);
  };

  updateUserGroup = async (id, payload, params) => {
    const endpoint = "user-groups/" + id;
    return await HttpService.put(endpoint, payload, params);
  };

  removeUserGroup = async (id, params) => {
    const endpoint = "user-groups/" + id;
    return await HttpService.delete(endpoint, params);
  };
}

export default new UserGroupService();
